var render = function render(){var _vm=this,_c=_vm._self._c;return _c('pop-panel',{attrs:{"name":'修改邮箱'}},[_c(_vm.currentPage,{tag:"component",attrs:{"form":_vm.form},on:{"change":_vm.changeHandler}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }